import React from 'react';
import PropTypes from 'prop-types';
import { formatDate, hasValue } from './maintenanceComplianceUtils';
import { ComplianceStatusBadge } from './MaintenanceComplianceBadges';
import MaintenanceComplianceRowActionsMenu from './MaintenanceComplianceRowActionsMenu';

const MaintenanceComplianceRow = ({
  label,
  valueText,
  badge,
  section,
  saveLoading,
  onRenew,
  onEdit,
}) => (
  <div className="maintenance-compliance-row">
    <span className="maintenance-compliance-row-label">{label}</span>
    <div className="maintenance-compliance-row-value-wrap">
      <span className="maintenance-compliance-row-value">
        {hasValue(valueText) ? valueText : '-'}
      </span>
      <ComplianceStatusBadge variant={badge.variant} label={badge.label} />
      {section && (
        <MaintenanceComplianceRowActionsMenu
          section={section}
          menuId={`maintenance-compliance-menu-${section}`}
          disabled={saveLoading}
          onRenew={onRenew}
          onEdit={onEdit}
        />
      )}
    </div>
  </div>
);

MaintenanceComplianceRow.propTypes = {
  label: PropTypes.string.isRequired,
  valueText: PropTypes.string,
  badge: PropTypes.shape({
    variant: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  section: PropTypes.oneOf(['roadTax', 'puspakom', 'insurance']),
  saveLoading: PropTypes.bool,
  onRenew: PropTypes.func,
  onEdit: PropTypes.func,
};

MaintenanceComplianceRow.defaultProps = {
  valueText: '',
  section: null,
  saveLoading: false,
  onRenew: undefined,
  onEdit: undefined,
};

export default MaintenanceComplianceRow;

export const formatRoadTaxValue = (expiry) => (
  hasValue(expiry) ? `Expires ${formatDate(expiry)}` : '-'
);

export const formatPuspakomValue = (nextDue) => (
  hasValue(nextDue) ? `Due ${formatDate(nextDue)}` : '-'
);

export const formatInsuranceValue = (expiry) => (
  hasValue(expiry) ? `Expires ${formatDate(expiry)}` : '-'
);
